import PropTypes from 'prop-types'
import { PureComponent, Suspense } from 'react'
import { connect } from 'react-redux'
import { Outlet } from 'react-router-dom'

import APP, { AuthUserSchema, Feature } from 'app'
import { ProgressBar, SimpleButton } from 'ui'

import { authAction, authLoginByCredentials } from 'actions/AuthActions'
import { environmentSet } from 'actions/EnvironmentActions'
import {
  SYSTEM_MESSAGE_ACTION,
  SYSTEM_MESSAGE_INITIAL_STATE,
  systemMessageCanceled,
  systemMessageShow,
} from 'actions/SystemMessageActions'

import '../../side-effects'

import './Widget.css'

const toggleDarkMode = () => {
  if (document.body.getAttribute('data-dark-mode')) {
    document.body.removeAttribute('data-dark-mode')
  } else {
    document.body.setAttribute('data-dark-mode', 'true')
  }
}

class Widget extends PureComponent {
  constructor(props) {
    super(props)
    this.props.environmentSet()
  }

  componentDidMount() {
    const script = document.createElement('script')
    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/iframe-resizer/4.3.2/iframeResizer.contentWindow.min.js'
    script.async = false
    document.body.append(script)

    if (APP.msg && !APP.msg.token) {
      this.props.systemMessageShow({
        ...SYSTEM_MESSAGE_INITIAL_STATE,
        msg: APP.msg.content,
        options: [
          {
            ...SYSTEM_MESSAGE_ACTION,
            content: 'OK',
            onClick: () => {
              const login = APP.msg.token !== undefined
              const accessAuth = APP.msg.accessAuth || null
              const accessCode = APP.msg.accessCode || null

              APP.msg = null
              APP.accessAuth = null
              APP.accessCode = null

              this.props.systemMessageCanceled()
              APP.history.push('/')

              if (accessAuth && accessCode) {
                this.props.authLoginByCredentials(accessAuth, accessCode)
              } else if (login) {
                this.props.authAction('login')
              }
            },
            primary: true,
          },
        ],
        title: APP.msg.title,
      })
    }
  }

  render() {
    const { authUser } = this.props

    return (
      <div className="Widget">
        {Feature.isEnabledForUser('dark_mode', authUser) && (
          <SimpleButton
            icon="moon outline"
            onClick={toggleDarkMode}
            style={{ bottom: 5, position: 'fixed', right: 10, zIndex: 1000 }}
          />
        )}
        <Suspense fallback={<ProgressBar ariaLabel="Cargando..." value={100} />}>
          <Outlet />
        </Suspense>
      </div>
    )
  }
}

Widget.propTypes = {
  authAction: PropTypes.func.isRequired,
  authLoginByCredentials: PropTypes.func.isRequired,
  authUser: AuthUserSchema,
  environmentSet: PropTypes.func.isRequired,
  systemMessageCanceled: PropTypes.func.isRequired,
  systemMessageShow: PropTypes.func.isRequired,
}

Widget.defaultProps = {
  authUser: null,
}

export default connect(({ auth: { usr } }) => ({ authUser: usr }), {
  authAction,
  authLoginByCredentials,
  environmentSet,
  systemMessageCanceled,
  systemMessageShow,
})(Widget)
